import createIcon from '../../createIcon';

/**
 * @component @name EditLocationAlt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuNDQ5IDEzLjVIOC40OTkwMlY4LjU1TDE0LjEwOSAyLjk0QzEzLjI3OSAyLjY2IDEyLjM5OSAyLjUgMTEuNDk5IDIuNUM3LjI5OTAyIDIuNSAzLjQ5OTAyIDUuNzIgMy40OTkwMiAxMC43QzMuNDk5MDIgMTQuMDIgNi4xNjkwMiAxNy45NSAxMS40OTkgMjIuNUMxNi44MjkgMTcuOTUgMTkuNDk5IDE0LjAyIDE5LjQ5OSAxMC43QzE5LjQ5OSA5LjY5IDE5LjMzOSA4Ljc2IDE5LjA0OSA3LjlMMTMuNDQ5IDEzLjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTAuNDk5IDExLjVIMTIuNjE5TDE4Ljc3OSA1LjM0TDE2LjY1OSAzLjIyTDEwLjQ5OSA5LjM4VjExLjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjAuMjA5IDIuNUwxOS40OTkgMS43OUMxOS4yOTkgMS42IDE5LjA0OSAxLjUgMTguNzg5IDEuNUMxOC42NTkgMS41IDE4LjMwOSAxLjU3IDE4LjA3OSAxLjc5TDE3LjM1OSAyLjUxTDE5LjQ3OSA0LjYzTDIwLjE5OSAzLjkxQzIwLjU5OSAzLjUyIDIwLjU5OSAyLjg5IDIwLjIwOSAyLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const EditLocationAlt = createIcon('EditLocationAlt', [
  [
    'path',
    {
      d: 'M13.449 13.5H8.49902V8.55L14.109 2.94C13.279 2.66 12.399 2.5 11.499 2.5C7.29902 2.5 3.49902 5.72 3.49902 10.7C3.49902 14.02 6.16902 17.95 11.499 22.5C16.829 17.95 19.499 14.02 19.499 10.7C19.499 9.69 19.339 8.76 19.049 7.9L13.449 13.5Z',
      key: 'oo3o3l',
    },
  ],
  ['path', { d: 'M10.499 11.5H12.619L18.779 5.34L16.659 3.22L10.499 9.38V11.5Z', key: 'mhecyq' }],
  [
    'path',
    {
      d: 'M20.209 2.5L19.499 1.79C19.299 1.6 19.049 1.5 18.789 1.5C18.659 1.5 18.309 1.57 18.079 1.79L17.359 2.51L19.479 4.63L20.199 3.91C20.599 3.52 20.599 2.89 20.209 2.5Z',
      key: '1eroay',
    },
  ],
]);

export default EditLocationAlt;
